var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProyectos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Flat",
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Color_copy",
    "data-name": "Color copy"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 41,
    fill: "#fcf2ad",
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 56,
    fill: "#fcf2ad",
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 53,
    fill: "#fcf2ad",
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 34,
    fill: "#fcf2ad",
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 24,
    fill: "#fcf2ad",
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 13,
    fill: "#fcf2ad",
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 8,
    fill: "#fcf2ad",
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 30,
    fill: "#fcf2ad",
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 23,
    fill: "#fcf2ad",
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 37,
    fill: "#fcf2ad",
    r: 2
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#d0d8da"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m51 42h-3a1 1 0 0 1 -.707-.293l-2.707-2.707h-5.586v-2h6a1 1 0 0 1 .707.293l2.707 2.707h2.586z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m44 27h-5v-2h4.323l3.748-9.371 1.858.742-4 10a1 1 0 0 1 -.929.629z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40 33h14v2h-14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47 31h-7v-2h6.279l1.772-5.316a1 1 0 0 1 .949-.684h4v2h-3.279l-1.772 5.316a1 1 0 0 1 -.949.684z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25 27h-4a1 1 0 0 1 -.707-.293l-2.707-2.707h-3.586v-2h4a1 1 0 0 1 .707.293l2.707 2.707h3.586z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15 29h9v2h-9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14 38h-3v-2h2.723l4.762-2.857a1 1 0 0 1 .515-.143h5v2h-4.723l-4.762 2.857a1 1 0 0 1 -.515.143z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15 48h-2v-5a1 1 0 0 1 .36-.769l6-5a1 1 0 0 1 .64-.231h5v2h-4.638l-5.362 4.469z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33 24h-2v-5.667l-2.8-3.733a1 1 0 0 1 -.2-.6v-4h2v3.667l2.8 3.733a1 1 0 0 1 .2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38 24h-2v-4a1 1 0 0 1 .445-.832l2.555-1.703v-2.465h2v3a1 1 0 0 1 -.445.832l-2.555 1.703z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28 24h-2v-5.586l-4.414-4.414h-6.586v-2h7a1 1 0 0 1 .707.293l5 5a1 1 0 0 1 .293.707z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31 40h2v15h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m49.293 50.707-4.707-4.707h-7.586a1 1 0 0 1 -1-1v-5h2v4h7a1 1 0 0 1 .707.293l5 5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24 51h-2v-4a1 1 0 0 1 .4-.8l3.6-2.7v-3.5h2v4a1 1 0 0 1 -.4.8l-3.6 2.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32 61a29 29 0 1 1 29-29 29.033 29.033 0 0 1 -29 29zm0-56a27 27 0 1 0 27 27 27.03 27.03 0 0 0 -27-27z"
  })), /*#__PURE__*/React.createElement("rect", {
    fill: "#b8bebf",
    height: 16,
    rx: 2,
    width: 16,
    x: 24,
    y: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40 36v2a2.006 2.006 0 0 1 -2 2h-12a2.006 2.006 0 0 1 -2-2v-12a2.006 2.006 0 0 1 2-2h2a12 12 0 0 0 12 12z",
    fill: "#93999a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30 28a3 3 0 0 0 -3 3v4a1 1 0 0 0 2 0v-1h2v1a1 1 0 0 0 2 0v-4a3 3 0 0 0 -3-3zm-1 4v-1a1 1 0 0 1 2 0v1z",
    fill: "#ade8f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36 28a1 1 0 0 0 -1 1v6a1 1 0 0 0 2 0v-6a1 1 0 0 0 -1-1z",
    fill: "#ade8f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m53 44a3 3 0 1 1 3-3 3 3 0 0 1 -3 3zm0-4a1 1 0 1 0 1 1 1 1 0 0 0 -1-1z",
    fill: "#f9dbaf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32 59a3 3 0 1 1 3-3 3 3 0 0 1 -3 3zm0-4a1 1 0 1 0 1 1 1 1 0 0 0 -1-1z",
    fill: "#f9dbaf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23 56a3 3 0 1 1 3-3 3 3 0 0 1 -3 3zm0-4a1 1 0 1 0 1 1 1 1 0 0 0 -1-1z",
    fill: "#f9dbaf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56 37a3 3 0 1 1 3-3 3 3 0 0 1 -3 3zm0-4a1 1 0 1 0 1 1 1 1 0 0 0 -1-1z",
    fill: "#f9dbaf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m55 27a3 3 0 1 1 3-3 3 3 0 0 1 -3 3zm0-4a1 1 0 1 0 1 1 1 1 0 0 0 -1-1z",
    fill: "#f9dbaf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40 16a3 3 0 1 1 3-3 3 3 0 0 1 -3 3zm0-4a1 1 0 1 0 1 1 1 1 0 0 0 -1-1z",
    fill: "#f9dbaf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29 11a3 3 0 1 1 3-3 3 3 0 0 1 -3 3zm0-4a1 1 0 1 0 1 1 1 1 0 0 0 -1-1z",
    fill: "#f9dbaf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13 33a3 3 0 1 1 3-3 3 3 0 0 1 -3 3zm0-4a1 1 0 1 0 1 1 1 1 0 0 0 -1-1z",
    fill: "#f9dbaf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12 26a3 3 0 1 1 3-3 3 3 0 0 1 -3 3zm0-4a1 1 0 1 0 1 1 1 1 0 0 0 -1-1z",
    fill: "#f9dbaf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9 40a3 3 0 1 1 3-3 3 3 0 0 1 -3 3zm0-4a1 1 0 1 0 1 1 1 1 0 0 0 -1-1z",
    fill: "#f9dbaf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31 31.94v.06h-2v-1a1 1 0 0 1 .64-.93 12.409 12.409 0 0 1 -.86-1.8 2.988 2.988 0 0 0 -1.78 2.73v4a1 1 0 0 0 2 0v-1h2v1a1 1 0 0 0 2 0v-1.25a12.259 12.259 0 0 1 -2-1.81z",
    fill: "#48cae4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36.82 35.57a1 1 0 0 1 -1.82-.57v-.08a12.275 12.275 0 0 0 1.82.65z",
    fill: "#48cae4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3 51h10v10h-10z",
    fill: "#00b4d8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13 51h-10l4-4h10z",
    fill: "#ade8f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17 47-4 4v10l4-4z",
    fill: "#48cae4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47 51h10v10h-10z",
    fill: "#00b4d8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57 51h-10l4-4h10z",
    fill: "#ade8f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m61 47-4 4v10l4-4z",
    fill: "#48cae4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47 7h10v10h-10z",
    fill: "#00b4d8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57 7h-10l4-4h10z",
    fill: "#ade8f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m61 3-4 4v10l4-4z",
    fill: "#48cae4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3 7h10v10h-10z",
    fill: "#00b4d8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13 7h-10l4-4h10z",
    fill: "#ade8f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17 3-4 4v10l4-4z",
    fill: "#48cae4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProyectos);
export default __webpack_public_path__ + "static/media/proyectos.2ff4d3111ca88ff7ebc7f97a18acc74d.svg";
export { ForwardRef as ReactComponent };